import { render, staticRenderFns } from "./TambahProgramPemilikSistem.vue?vue&type=template&id=72dc2f58&"
import script from "./TambahProgramPemilikSistem.vue?vue&type=script&lang=js&"
export * from "./TambahProgramPemilikSistem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports